// Map a number in one range to another range.
export default ({
  value = 0,
  inMin = 0,
  inMax = 1,
  outMin = 0,
  outMax = 1,
}) => (
  (((Math.min(inMax, Math.max(value, inMin)) - inMin) * (outMax - outMin)) / (inMax - inMin)) + outMin
);
